export const ANIMATION_PROPS = { height: 20, width: 20 } as const;
